import React, { useEffect, useState } from 'react';
import { useLocation, matchPath } from 'react-router-dom';
import { Col, Row } from 'reactstrap';

import Alert from '../../ui/Alert';
import Tab from '../../ui/Tab';
import TabPanel from '../../ui/TabPanel';
import Tabs from '../../ui/Tabs';
import Page from '../Page';
import ExistingInvoices from './ExistingInvoices';
import UninvoicedSessions from './UninvoicedSessions';

const blockEl = 'invoices';

const Invoices = () => {
  const location = useLocation();
  const [showCatalogsNotSameLocationBanner, setShowCatalogsNotSameLocationBanner] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    setTabIndex(matchPath(location.pathname, {
      path: '/invoices/ExistingInvoices',
      exact: false
    }) ? 1 : 0);
  }, [location]);

  return (
    <Page className={blockEl} header={{ title: 'Manage All Invoices' }}>
      <Row>
        <Col xs="12">
          <Alert
            className={`${blockEl}__banner`}
            color="warning"
            isOpen={showCatalogsNotSameLocationBanner}
            onClose={() => {
              setShowCatalogsNotSameLocationBanner(false);
            }}
          >
            Invoice Groups can only contain catalogs that had the same sale location for sales tax calculation. Please create separate invoice groups for the selected catalogs
          </Alert>
        </Col>
      </Row>
      <Tabs value={tabIndex} onChange={setTabIndex}>
        <Tab
          label="Uninvoiced Sessions"
        />
        <Tab label="Existing Invoices" />
      </Tabs>
      <TabPanel value={tabIndex} index={0}>
        <UninvoicedSessions
          toggleCatalogsNotInSameLocationBanner={setShowCatalogsNotSameLocationBanner}
        />
      </TabPanel>
      <TabPanel value={tabIndex} index={1}>
        <ExistingInvoices />
      </TabPanel>
    </Page>
  );
};

export default Invoices;
